// client/entityStore.ts
import { fromNetwork } from "../symbols.js";
var EntityStore = class {
  static {
    /** main storage object */
    this.store = {};
  }
  static {
    /** mapping of which properties should be used as cache keys */
    this.keyMap = {};
  }
  /**
   * set the cache key for a given _class of entities.
   *
   * By default the _id property is used to index the cache entries, but any string value can be used instead.
   */
  static setCacheKey(entityClass, keyProperty) {
    this.keyMap[entityClass] = keyProperty;
  }
  /** get the cache key if one is set, otherwise returns '_id' */
  static getCacheKey(entityClass) {
    return this.keyMap[entityClass] ?? "_id";
  }
  /**
   * get an entity reference matching the value if present and call `mergeData` on it.
   */
  static getAndMerge(value, field) {
    const entity = this.store[value._class]?.[this.resolveKey(value._class, value, field)];
    if (entity)
      entity.mergeData(value, value[fromNetwork]);
    return entity;
  }
  static get(entityClass, key) {
    return this.store[entityClass]?.[key];
  }
  /**
   * put an entity into the cache
   */
  static put(entity, field) {
    const key = this.resolveKey(entity._class, entity, field);
    if (!key)
      return entity;
    if (!this.store[entity._class])
      this.store[entity._class] = {};
    return this.store[entity._class][key] = entity;
  }
  /**
   * deletes the reference to the entity out of the cache
   */
  static drop(entity, field) {
    const key = this.resolveKey(entity._class, entity, field);
    if (!key || !this.store[entity._class])
      return;
    delete this.store[entity._class][key];
  }
  /**
   * Tries to resolve the value of a specific property within a given object.
   * Will use AdornisEntities resolveID function if implemented.
   *
   * Accepts dot separated strings to index nested objects.
   *
   * @retruns value at index or undefined
   */
  static resolveKey(entityClass, value, field) {
    const index = this.keyMap[entityClass] || "_id";
    const resolved = this.resolveStringKey(index, value);
    if (!resolved)
      try {
        return (field?.type()).resolveID(value);
      } catch {
      }
    return resolved;
  }
  /**
   * resolve the value at a given index of the given object.
   *
   * Accepts dot separated strings to index nested objects.
   */
  static resolveStringKey(index, value) {
    if (typeof value !== "object")
      return;
    if (!Array.isArray(index))
      index = index.split(".");
    const [first, ...rest] = index;
    if (!first)
      return;
    if (!rest.length)
      return value[first];
    return this.resolveStringKey(rest, value[first]);
  }
};
window.EntityStore = EntityStore;
export {
  EntityStore
};
